<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial District Selection Chess Tournament 2026, Chh. Sambhajinagar </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial District Selection Chess Tournament 2026, Chh. Sambhajinagar </span></h2>
        </div>
        <p><strong> Date: </strong>May 3, 2026</p>
        <p><strong> Venue: </strong>Mahesh Bhavan, Gulmandi, Chhatrapati Sambhajinagar</p>
        <p><strong> Organized By: </strong>Amrish Chess Academy</p>
        <p><strong> Under the Aegis of: </strong>Aurangabad Chess Association</p>
        <p><strong> In Association With: </strong>Raisoni Foundation & Kalpana Prakash Welfare Foundation</p>
        <p><strong> Total Prize Fund: </strong>₹20,000</p>
        <h5 class="primary-purple">Introduction:</h5>
        <p> The G.H. Raisoni Memorial Chh. Sambhajinagar District Selection Chess Tournament 2026 was
            successfully conducted on May 3, 2026, at the campus of Mahesh Bhavan, Gulmandi, Chhatrapati
            Sambhajinagar. The prestigious event was organized by Amrish Chess Academy under the aegis of
            Aurangabad Chess Association, in association with the Raisoni Foundation and Kalpana Prakash
            Welfare Foundation.</p>

        <p> The tournament aimed to provide a competitive platform for both budding and experienced chess
            players of the Chhatrapati Sambhajinagar District.</p>
        <p> Chhatrapati Sambhajinagar is a culturally rich city in Maharashtra with growing interest in chess and
            other mind sports. This tournament marked one of the major district-level chess events organized in the
            region. The primary objective of this initiative was to reach talented players from different parts of the
            district and provide them with a professional and standardized platform to showcase their strategic
            abilities.</p>
        <p>The tournament was conducted smoothly, following FIDE Laws of Chess and standard Swiss System
            pairing procedures appropriate to each category.</p>
        <p> All rounds started on time and were completed in a disciplined and sportsmanlike atmosphere.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/gh-raisoni-sambhajinagar-report-may.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
